import { isInjectableKey } from './injector';
/** The name of the module */
export const name = 'DataHydration';
/** Global hydration queue */
window.hydrationQueue = window.hydrationQueue || [];
/**
 * All the hydration data being stored. Keys on the object are the name of a module (e.g. PagedCarousel), which
 * is an array of data for each instance of that module on the page
 *
 * @type {Object}
 * @property {String} hydrationData.{moduleName}
 */
const parsedHydrationData = {};
/**
 * Take data that was added to the hydration queue and add it to the final hydration data variable
 *
 * @param {Object} data - Object keyed by module name with data to hydrate
 */
const parseHydrationDataQueue = (data) => {
    Object.keys(data).forEach((key) => {
        if (key in parsedHydrationData) {
            parsedHydrationData[key].push(data[key]);
        }
        else {
            parsedHydrationData[key] = [data[key]];
        }
    });
};
/**
 * Fetch the hydration data for a particular module (key), or all hydrated modules
 *
 * @param key A key representing the module's data being requested
 */
export function getParsedHydrationData(key) {
    if (isInjectableKey(key) && key.length && key in parsedHydrationData && Array.isArray(parsedHydrationData[key])) {
        return parsedHydrationData[key];
    }
    if (typeof key === 'undefined' || key === null) {
        return parsedHydrationData;
    }
    return [];
}
/**
 * Function called when the module is executed to parse existing hydration in queue and redefine the queue's .push()
 * function to call parseHydrationData directly instead of adding to the queue.
 */
const processHydrationQueue = () => {
    window.hydrationQueue.forEach(parseHydrationDataQueue);
    window.hydrationQueue = [];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.hydrationQueue.push = parseHydrationDataQueue;
};
/**
 * This should only be used for unit tests
 */
export const clearHydrationData = () => {
    for (const prop of Object.getOwnPropertyNames(parsedHydrationData)) {
        delete parsedHydrationData[prop];
    }
};
// Hydrate any existing data already pushed into queue
processHydrationQueue();
